
/**
 * @export
 * @enum {string}
 */
export enum DecorationType {
    ENTITY = 'ENTITY',
    REPORT = 'REPORT'
}